<template>
  <main id="pallet-receipt-main">
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('palletReceipt.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter"/>
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('palletReceipt.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')"
                          placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini"
                           class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <add-dialog-button/>
              <reports/>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';
import WarehouseList from '@/components/WarehouseList/WarehouseList';
import { PALLET_RECEIPT_SHIPPER_SEARCH, PALLET_RECEIPT_SET_DEFAULT_FILTERS } from '@/store/actions';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import AddDialogButton from './components/AddDialog';
import Reports from './components/Reports';

export default {
  name: 'PalletReceipt',
  components: {
    SearchFilter,
    SearchSummary,
    WarehouseList,
    AddDialogButton,
    Reports
  },
  data() {
    return {
      actionMountChained: [PALLET_RECEIPT_SET_DEFAULT_FILTERS],
      actionSelectChained: [PALLET_RECEIPT_SHIPPER_SEARCH],
      shippers: constants.ACCOUNTS.TYPE[1].value
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
